import PropTypes from 'prop-types';
import {Component} from 'react';
import Translation from '../../../lang/Translation';

export default class ItemCount extends Component {
  getTranslationKey = () => {
    if (this.props.count === 1) return 'item';
  
    // Czech and Slovak have different grammar in this case:
    if (this.props.count > 1 && this.props.count < 5) return 'items.twoToFour';
    
    return 'items';
  };
  
  render() {
    return (
      <Translation placeholderValues={[this.props.count]} optionalExtension={this.props.siteCode}>
        {this.getTranslationKey()}
      </Translation>
    );
  }
}

ItemCount.propTypes = {
  count: PropTypes.number.isRequired,
  siteCode: PropTypes.string,
};
